import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { GlobalFunctionsService } from '../services/global-functions.service';
import { LoginServiceServiceService } from '../services/login-service-service.service';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpClient } from '@angular/common/http';
import { DemoService } from '../demo.service';

@Component({
  selector: 'app-login-enter-code-tfa',
  templateUrl: './login-enter-code-tfa.component.html',
  styleUrls: ['./login-enter-code-tfa.component.scss']
})
export class LoginEnterCodeTFAComponent implements OnInit {


  tfa: any = {};
  authcode: any = "";
  errorMessage: string = null;
  confirmPass: string = ""

  tfaFlag: boolean = false
  userObject = {
    uname: "",
    upass: "",
    authcode: "",
    secret: this.gfunc.tfa_secret
  }
  user_id: any;
  brand_id: any;
 
  access_level: any;
  user_password_expiry_date: any;
  user: any;
  tfa_result: any;
  tfa_result_confirm: any;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    
    private authenticationService: AuthenticationService,
    public gfunc: GlobalFunctionsService,
    // private alertService: AlertService,
    // public toastr: HotToastService,
    vcr: ViewContainerRef,
    public toastr: HotToastService,
    public _loginService: LoginServiceServiceService,
  ) {

    // This should hide the entire side menu
          const div = document.getElementById('side-menu');
         if(div) {
           div.style.display = 'none'
           div.style.backgroundColor = '#000;'
         }

         const header_div = document.getElementById('navbar-header');
         if(header_div) {
          header_div.style.display = 'none'
         }

   }

  ngOnInit(): void {

    this.user_id = this.gfunc.sessionUserId;
    this.getUserById(this.user_id);
  }



  globalDashboardSkipRoute(){
this.gfunc.activateTFACodeEntered(); // sets the global variable to stop just skipping and entering in a route. (this.gfunc.tfa_code_in_use must = 1)
this.gfunc.globalDashboardSkipRoute()
  }


  getUserById(user_id) {

    this._demoService.getUsersById(user_id).subscribe(
       data => { this.user = data;
        this.brand_id = this.user.map(function(a) {return a ['brand_id']; });
        this.access_level = this.user.map(function(a) {return a ['access_level']; });
        this.user_password_expiry_date = this.user.map(function(a) {return a ['password_expiry_date']; });


             // get auth service details
          
          // CHANGE THIS TO LOAD MY OWN FROM THE DATABASE AND  if needed???
               // this.getAuthDetails();
  
      },
       err =>{ 
        console.log('Could not get the user.');
        // this.user_password_date_status_expired = 1;
        // this.openModalWithComponent_PasswordExpired();
        
        console.error(err)},
       () => console.log(' Loaded User details correctly.')
     );
  }





  resetRemoveUserTSA(model){
    if (confirm('Are you sure? This will reset your TFA with your login, and require you to setup again. You will be logged out if you proceed.')) {
    // pass the user model
    let update_model = {
      // ...data.body,
      ...model,
    }
    update_model[0].is_tfa_enforced = 0
    update_model[0].is_tfa_setup_passed = 0
    update_model[0].tfa_secret = ''
    update_model[0].tfa_tempSecret = this.tfa.tempSecret
    update_model[0].tfa_dataURL = this.tfa.dataURL
    update_model[0].tfa_tfaURL = this.tfa.tfaURL
  
    console.log("update Model: " + JSON.stringify(update_model));
  
      this.updateBrandUser(update_model[0]); 
  
      setTimeout(() => {
        // this.router.navigate(['/admin']);
        this.gfunc.logout();
        }, 6000);
  
  
      }
  
  }

  // update was here for onit but moved for onchange
  updateBrandUser(model) {
    // model.email_signature_HTML_rendered = this.email_signature_HTML_rendered;
  this._demoService.updateBrandUser(model).subscribe(
     data => {
      console.log(model);
       // this.trace_candidate_update = data;
            this.toastr.success('User Updated');
            //  this.gfunc.globalRouteViewSkipRoute("/admin") // redirect after update / register user for TFA
      // this.gfunc.setLoginSessionVars(); // just seeing if I need to set these to get the values
  
  
     // Subject to reload the manager component parent.
    // BrandUserManagerComponent.returned.next(false);
       return true;
     },
     error => {
       console.error('Error saving User!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
  );
  }
  


skip_tfa_button(model){
  this.gfunc.insertLog_TFA_login_skipped(model);
  this.globalDashboardSkipRoute();
}





// This now authenticates the Uuthcode
loginUser_backvault() {

  // set the values here from login so that I dont have to have the user enter them again

  this.userObject.uname = this.gfunc.sessionUserName
  this.userObject.upass = this.gfunc.sessionUserPasswordHash

    // check if it is the current user just in case.
    // if(this.gfunc.sessionUserName != this.userObject.uname.trim()){
    //   alert('Hey, Make sure you enter your login details. Or you may have made a mistake entering your details. Try again.')
    //   return;
    // }

  this._loginService.loginAuth_backvault(this.userObject).subscribe((data) => {
    this.errorMessage = null;
    if (data.body['status'] === 200) {
      this._loginService.updateAuthStatus(true);
      // this.router.navigateByUrl('/admin/jobs/dashboard');
this.toastr.success("Code Accepted");

this.gfunc.insertLog_TFA_login_passed(data.body);

this.gfunc.activateTFACodeEntered(); // sets the global variable to stop just skipping and entering in a route. (this.gfunc.tfa_code_in_use must = 1)
  
this.gfunc.globalDashboardSkipRoute();
          // if(this.gfunc.sessionUserLevel <= 3){
          // this.router.navigateByUrl('/admin/jobs/dashboard');
          // }
          // if(this.gfunc.sessionUserLevel == 9){
          //   this.router.navigateByUrl('/client/dashboard');
          //   }
          //   if(this.gfunc.sessionUserLevel == 5){
          //     this.router.navigateByUrl('/agent/dashboard');
          //   }
          //   if(this.gfunc.sessionUserLevel == 4){
          //     this.router.navigateByUrl('/staff/dashboard');
          //   }




    }
    if (data.body['status'] === 206) {
      this.tfaFlag = true;
      this.toastr.error("Sorry, Your Code has not been accepted, try again. "  + this.tfaFlag);
      this.gfunc.insertLog_TFA_login_failed(data.body);

    }
    if (data.body['status'] === 403) {
      this.errorMessage = data.body['message'];
      this.toastr.error(" "  + this.errorMessage );
      this.gfunc.insertLog_TFA_login_failed(data.body);
    }
    if (data.body['status'] === 404) {
      this.errorMessage = data.body['message'];
      this.toastr.error(" "  + this.errorMessage );
      this.gfunc.insertLog_TFA_login_failed(data.body);
    }
  })
}




getAuthDetails() {
  this._loginService.getAuth().subscribe((data) => {
    const result = data.body
    if (data['status'] === 200) {
      console.log(result);
              
                this.toastr.warning('Retrived Your Auth Details')
                console.log("Ret AuthDetails: " + JSON.stringify(data.body) )

                // this.toastr.success('Time now to Take a Photo of the QR code the Authenticator App')
                // Update the user details Database
                // I think I need now to either update the user session variables or update the entire models...
                          //   this.tfa_result = result;
                          //   if(this.tfa_result){


                              
                          //   let update_model = {
                          //     // ...data.body,
                          //     ...this.user,
                          //   }
                          //   update_model[0].is_tfa_setup_passed = false
                          //   update_model[0].tfa_secret = this.tfa_result.secret
                          //   update_model[0].tfa_tempSecret = this.tfa_result.tempSecret
                          //   update_model[0].tfa_dataURL = this.tfa_result.dataURL
                          //   update_model[0].tfa_tfaURL = this.tfa_result.tfaURL

                          //   console.log("update Model: " + JSON.stringify(update_model));

                          //     this.updateBrandUser(update_model[0]); 
                          //   // this.toastr.success('Setup Result: Updated User Database');
                          // }// end if

      if (result == null) {
       // this.setup();
      } else {
        this.tfa = result;






      }
    }
  });
}



}
